// extracted by mini-css-extract-plugin
export default {"disclamer":"Disclaimer_disclamer__PG7Mr","download_btn":"Disclaimer_download_btn__0uOLv"};